import moment from 'moment';
import { useGetUserTimeZone } from 'hooks';

const getNowDate = (timeZone) =>
  moment
    .utc()
    .tz(timeZone || 'America/New_York')
    .valueOf();

export default function getIndex(arr, league) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { timeZone: userTimeZone } = useGetUserTimeZone();

  if (!arr || arr.length === 0) {
    return 0;
  }

  // If a specific game is selected via URL, use that
  const params = new URLSearchParams(window.location.search);
  const gameId = params.get('eventId');

  if (gameId) {
    const foundIndex = arr.findIndex(
      (game) => game.event_id === Number(gameId)
    );
    // Only return the found index if it exists
    // If not found, fall through to current event logic below
    if (foundIndex !== -1) {
      return foundIndex;
    }
  }

  const now = getNowDate(userTimeZone);

  // Find the current or next game
  // Game is considered "current" if:
  // 1. It hasn't started yet (future game), OR
  // 2. It started within the last 5 hours (likely in progress)
  const GAME_DURATION_HOURS = 5; // Padding to account for games in progress

  const currentIndex = arr.findIndex((game) => {
    const gameStart = moment
      .utc(game.event_start, 'YYYY-MM-DD HH:mm:ss')
      .valueOf();
    const gameEnd = moment
      .utc(game.event_start, 'YYYY-MM-DD HH:mm:ss')
      .add(GAME_DURATION_HOURS, 'hours')
      .valueOf();

    if (league) {
      // For league view: only show upcoming games (not in-progress)
      return gameStart > now;
    } else {
      // For team view: show in-progress OR upcoming games
      // Game is current if it hasn't ended yet (start + 5 hours)
      return now < gameEnd;
    }
  });

  // If no game found (all games are in the past), show the last game
  if (currentIndex === -1) {
    return arr.length - 1;
  }

  return currentIndex;
}
